import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import HistoryDeadlineTableBody from './HistoryDeadlineTableBody';
import type { HistoryDeadlineRow } from './model';

interface HistoryDeadlineTableProps {
    rows: HistoryDeadlineRow[];
    loading: boolean;
}

const HistoryDeadlineTable = ({ rows, loading }: HistoryDeadlineTableProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={loading} />
            <div className="crm-table-wrap history-deadline-table-wrap">
                <Table className="HistoryDeadlineTable table-hover mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-username">{t('historyDeadline.cols.user')}</td>
                            <td className="head-date">{t('historyDeadline.cols.date')}</td>
                            <td className="head-change">{t('historyDeadline.cols.change')}</td>
                            <td className="head-comment">{t('historyDeadline.cols.comment')}</td>
                        </tr>
                    </thead>
                    <HistoryDeadlineTableBody rows={rows} loading={loading} />
                </Table>
            </div>
        </div>
    );
};

export default HistoryDeadlineTable;
